export function camelCaseToTitleCase(text) {
    const result = text.replace(/([A-Z]|[0-9]+)/g, " $1");
    return result.charAt(0).toUpperCase() + result.slice(1);
}
